import { useState } from "react";
import {
    TextField,
    Button,
    Box,
    Typography,
    InputAdornment,
} from "@mui/material";

const RecommendedInput = ({
    metalType,
    goldPrice,
    silverPrice,
    amount,
    onAmountSelect,
    gramValue,
    setGramValue,
    formErrors,
}) => {
    // Recommended values
    const recommendedValues = [100, 200, 300, 400, 500];

    const handleRecommendedClick = (value) => {
        onAmountSelect(value);
        const gstRate = 1.03;
        setGramValue(
            value
                ? (
                    value /
                    gstRate /
                    (metalType === "Gold" ? goldPrice : silverPrice)
                ).toFixed(4)
                : ""
        );
    };

    return (
        <Box
            sx={{
                width: "100%",
                margin: "auto",
                mt: { xs: 2, sm: 4 },
                textAlign: "center",
            }}
        >
            {/* ✅ Amount Input */}
            <TextField
                required
                fullWidth
                label="Enter amount"
                value={amount}
                onChange={(e) => {
                    handleRecommendedClick(e.target.value);
                }}
                error={!!formErrors?.SelectAmount}
                helperText={formErrors?.SelectAmount}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Typography fontSize={{ xs: "16px", sm: "18px" }}>
                                ₹
                            </Typography>
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <Typography
                                fontSize={{ xs: "12px", sm: "14px" }}
                                color="text.secondary"
                            >
                                {gramValue} gm
                            </Typography>
                        </InputAdornment>
                    ),
                }}
            />

            {/* ✅ Minimum Text */}
            <Typography
                variant="body2"
                color="textSecondary"
                sx={{
                    textAlign: "left",
                    mt: { xs: 1, sm: 1 },
                    mb: { xs: 0.5, sm: 2 },
                    fontSize: { xs: "12px", sm: "14px" },
                }}
            >
                Minimum ₹100
            </Typography>

            {/* ✅ Recommended Label */}
            <Typography
                color="textSecondary"
                sx={{
                    mb: { xs: 2, sm: 2 },
                    fontSize: { xs: "13px", sm: "16px" },
                    fontWeight: 500,
                }}
            >
                Recommended :
            </Typography>

            {/* ✅ Recommended Buttons */}
            <Box
                display="flex"
                justifyContent={{ xs: "space-between", sm: "center" }}
                alignItems="center"
                gap={{ xs: 0.5, sm: 1.5, md: 2 }}
                flexWrap="nowrap"
                mb={3}
            >
                {recommendedValues.map((value) => (
                    <Button
                        key={value}
                        sx={{
                            flex: 1,
                            height: { xs: 34, sm: 45, md: 50 }, // ✅ Different heights
                            minWidth: { xs: 48, sm: 80, md: 100 },
                            maxWidth: { xs: 64, sm: 100, md: 120 },
                            fontSize: { xs: "12px", sm: "14px", md: "15px" },
                            padding: { xs: "4px 2px", sm: "6px 8px" },
                            backgroundColor:
                                value === amount ? "#4a2a7d" : "#cfbae5",
                            color: value === amount ? "#fff" : "#000",
                            borderRadius: "8px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            lineHeight: 1.2,
                            "&:hover": {
                                backgroundColor:
                                    value === amount
                                        ? "#3a1f67"
                                        : "#b7a0cf",
                            },
                        }}
                        onClick={() => handleRecommendedClick(value)}
                    >
                        ₹{value}
                    </Button>
                ))}
            </Box>
        </Box>
    );
};

export default RecommendedInput;

// import { useState } from "react";
// import { TextField, Button, Box, Typography, InputAdornment } from "@mui/material";

// const RecommendedInput = ({ metalType, goldPrice, silverPrice, amount, onAmountSelect, gramValue, setGramValue, formErrors }) => {
//     // Recommended values
//     const recommendedValues = [100, 200, 300, 400, 500];
//     const handleRecommendedClick = (value) => {
//         onAmountSelect(value)
//         const gstRate = 1.03;
//         setGramValue(
//             value
//                 ? (
//                     value /
//                     gstRate /
//                     (metalType == "Gold" ? goldPrice : silverPrice)
//                 ).toFixed(4)
//                 : ""
//         );
//     };

//     return (
//         <Box sx={{ width: "100%", margin: "auto", mt: { xs: 1, sm: 4 }, textAlign: "center" }}>
//             <TextField
//                 required

//                 fullWidth
//                 label="Enter amount"
//                 // placeholder="Enter amount"
//                 value={amount}
//                 onChange={(e) => { handleRecommendedClick(e.target.value) }}
//                 error={!!formErrors?.SelectAmount}
//                 helperText={formErrors?.SelectAmount}
//                 InputProps={{
//                     startAdornment: (
//                         <InputAdornment position="start">
//                             <Typography >₹</Typography>
//                         </InputAdornment>
//                     ),
//                     endAdornment: (
//                         <InputAdornment position="end">
//                             <Typography >{gramValue} gm</Typography>
//                         </InputAdornment>
//                     ),

//                 }}
//             />

//             <Typography
//                 variant="body2"
//                 color="textSecondary"
//                 sx={{ textAlign: "left", marginTop: { xs: 0, sm: 1 }, marginBottom: { xs: 0, sm: 2 } }}
//             >
//                 Minimum ₹100
//             </Typography>

//             <Typography variant="subtitle1" color="textSecondary"
//                 sx={{ marginBottom: { xs: 1, sm: 2 } }}>
//                 Recommended :
//             </Typography>
//             <Box display="flex"
//                 justifyContent={{ xs: "space-between", md: "space-around" }}
//                 alignItems="center"
//                 gap={{ xs: 0.3, md: 2 }}
//                 mb={2}
//                 sx={{
//                     width: "100%",
//                     flexWrap: "nowrap", // ✅ Always one row
//                 }}>
//                 {/* <Box sx={{ display: "flex", justifyContent: "space-around" }}> */}
//                 {recommendedValues.map((value) => (
//                     <Button
//                         // selected={value === amount}
//                         key={value}
//                         // variant="contained"
//                         // sx={{
//                         //     p: { xs: 0.5, sm: 1 },
//                         //     backgroundColor: value === amount ? "#4a2a7d" : "#cfbae5",
//                         //     color: value === amount ? "white" : "black",
//                         //     "&:hover": { backgroundColor: "#b7a0cf" },
//                         //     maxWidth: "60px",
//                         // }}
//                         sx={{
//                             flex: 1, // ✅ Equal width for all buttons
//                             height: { xs: 30, sm: 60, md: 50 }, // ✅ Equal height
//                             maxWidth: { xs: 20, md: 120 }, // ✅ Better alignment on desktop
//                             fontSize: { xs: "12px", sm: "13px", md: "14px" },
//                             padding: { xs: "5px 4px", md: "8px 8px" },

//                             display: "flex",
//                             flexDirection: {
//                                 xs: "column", // ✅ Mobile: stacked
//                                 md: "row", // ✅ Desktop: normal text
//                             },
//                             justifyContent: "center",
//                             alignItems: "center",
//                             // whiteSpace: "normal",
//                             // textAlign: "center",
//                             lineHeight: 1.2,
//                             // p: { xs: 0.1, sm: 1 },
//                             backgroundColor: value === amount ? "#4a2a7d" : "#cfbae5",
//                             color: value === amount ? "white" : "black",
//                             "&:hover": { backgroundColor: "#b7a0cf" },
//                         }}
//                         onClick={() => handleRecommendedClick(value)}
//                     >
//                         ₹{value}
//                     </Button>
//                 ))}
//             </Box>
//         </Box>
//     );
// };

// export default RecommendedInput;
